export default "__VITE_ASSET__8naN16pB__"